/** Angular */
import { NgModule } from '@angular/core';
/** Modules */
import { DsLibSharedModule } from '../shared/ds-lib-shared.module';
import { DsLibMaterialModule } from '../shared/ds-lib-material.module';

@NgModule({
  exports: [DsLibSharedModule, DsLibMaterialModule],
})
export class DsLibCommonModule {}
